import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import type { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import { airportTransferBenefitDescription } from 'loyalty/pages/LoyaltyLandingPageData'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

function LandingPageLoyaltyAirportTransferBenefitsModal() {
  const intl = useIntl()
  const image = useMemo<App.Image>(() => ({
    id: '0qt5tc9nvf1qd3f0t5fe',
    title: intl.formatMessage({
      id: '2HRtf-FUlQHl0uAxrGqo',
      defaultMessage: 'Free airport chauffeur service',
      description: 'Alternative text fallback for the airport chauffeur service loyalty benefit image',
    }),
  }), [intl])

  return (
    <ModalBase size="L">
      <ModalHeader title={intl.formatMessage({
        id: 'DMAv70kqkCc5B9tV55IC',
        defaultMessage: 'Free airport chauffeur service',
        description: 'Title for the airport chauffeur transfer benefit details modal',
      })}
      />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="airport_transfer" />
            <BodyText variant="large">
              {intl.formatMessage(airportTransferBenefitDescription)}
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">{intl.formatMessage({
                id: '-Z5NgsPpxp6OsHbsBnfP',
                defaultMessage: 'How it works',
                description: 'Section heading explaining how the airport transfer benefit works',
              })}
              </Heading>
              <BodyText variant="large">
                {intl.formatMessage({
                  id: 'LhVV9S-LHJ6ZDBQ45wYH',
                  defaultMessage: 'When booking select overseas travel, you’ll have the option to add a private transfer during checkout. Once selected, your transfer will automatically be added to your booking at no additional cost.',
                  description: 'Explanation in the airport transfer benefit modal of how a member adds the transfer during checkout',
                })}
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyAirportTransferBenefitsModal
